export default "__VITE_ASSET__5oSOnCKy__"